import { IIndexInfoAvailable } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import { formatAddress } from "@rentiohq/shared-frontend/dist/utils/address.utils";
import { formatDate } from "@rentiohq/shared-frontend/dist/utils/date.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";

export const getIndexationLetterTitle = (params: { property: IProperty }) => {
  const { property } = params;

  return getLocalizedText(
    "activity.template_document.title.indexation_letter",
    { address: formatAddress(property), date: formatDate(new Date()) },
  );
};

export const getIndexInfoForInternalMode = (
  indexInfoAvailable: IIndexInfoAvailable,
) => {
  return {
    "New price & increase": `${indexInfoAvailable.newPrice} | ${indexInfoAvailable.increase}`,
    "New price & increase - EPC D": `${indexInfoAvailable.newPriceEpcD} | ${indexInfoAvailable.increaseEpcD}`,
    "New price & increase - EPC E": `${indexInfoAvailable.newPriceEpcE} | ${indexInfoAvailable.increaseEpcE}`,
    "New price & increase - EPC F": `${indexInfoAvailable.newPriceEpcF} | ${indexInfoAvailable.increaseEpcF}`,
    "New price & increase - EPC G": `${indexInfoAvailable.newPriceEpcG} | ${indexInfoAvailable.increaseEpcG}`,
    "New price & increase - NO EPC": `${indexInfoAvailable.newPriceNoEpc} | ${indexInfoAvailable.increaseNoEpc}`,

    // "New common cost price & increase": `${indexInfoAvailable.newCommonCostsPrice} | ${indexInfoAvailable.increaseCommonCosts}`,
    "New common cost price & increase - EPC D": `${indexInfoAvailable.newCommonCostsPriceEpcD} | ${indexInfoAvailable.increaseCommonCostsEpcD}`,
    "New common cost price & increase - EPC E": `${indexInfoAvailable.newCommonCostsPriceEpcE} | ${indexInfoAvailable.increaseCommonCostsEpcE}`,
    "New common cost price & increase - EPC F": `${indexInfoAvailable.newCommonCostsPriceEpcF} | ${indexInfoAvailable.increaseCommonCostsEpcF}`,
    "New common cost price & increase - EPC G": `${indexInfoAvailable.newCommonCostsPriceEpcG} | ${indexInfoAvailable.increaseCommonCostsEpcG}`,
    "New common cost price & increase - NO EPC": `${indexInfoAvailable.newCommonCostsPriceNoEpc} | ${indexInfoAvailable.increaseCommonCostsNoEpc}`,

    // "New non-common cost price & increase": `${indexInfoAvailable.newNonCommonCostsPrice} | ${indexInfoAvailable.increaseNonCommonCosts}`,
    "New non-common cost price & increase - EPC D": `${indexInfoAvailable.newNonCommonCostsPriceEpcD} | ${indexInfoAvailable.increaseNonCommonCostsEpcD}`,
    "New non-common cost price & increase - EPC E": `${indexInfoAvailable.newNonCommonCostsPriceEpcE} | ${indexInfoAvailable.increaseNonCommonCostsEpcE}`,
    "New non-common cost price & increase - EPC F": `${indexInfoAvailable.newNonCommonCostsPriceEpcF} | ${indexInfoAvailable.increaseNonCommonCostsEpcF}`,
    "New non-common cost price & increase - EPC G": `${indexInfoAvailable.newNonCommonCostsPriceEpcG} | ${indexInfoAvailable.increaseNonCommonCostsEpcG}`,
    "New non-common cost price & increase - NO EPC": `${indexInfoAvailable.newNonCommonCostsPriceNoEpc} | ${indexInfoAvailable.increaseNonCommonCostsNoEpc}`,

    "Correction factors - EPC D": indexInfoAvailable.correctionFactorEpcD,
    "Correction factors - EPC E": indexInfoAvailable.correctionFactorEpcE,
    "Correction factors - EPC F": indexInfoAvailable.correctionFactorEpcF,
    "Correction factors - EPC G": indexInfoAvailable.correctionFactorEpcG,
    "Correction factors - NO EPC": indexInfoAvailable.correctionFactorNoEpc,

    "Retroactive months": indexInfoAvailable.retroactivityMonths,
    "Retroactive price": indexInfoAvailable.retroactivityPrice,
    "Retroactive period start": indexInfoAvailable.retroactivityPeriodStart
      ? formatDate(indexInfoAvailable.retroactivityPeriodStart)
      : undefined,
    "Retroactive period end": indexInfoAvailable.retroactivityPeriodEnd
      ? formatDate(indexInfoAvailable.retroactivityPeriodEnd)
      : undefined,

    "Epc based indexation type": indexInfoAvailable.epcBasedIndexationType,
  };
};
